(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        // eslint-disable-next-line no-console
        this.score = 0;
        this.status = "idle";
        this.initialState = initialState ? initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        }) : Array.from({
            length: 4
        }, function() {
            return Array(4).fill(0);
        });
        this.board = this.initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this;
                var oldBoard = this.getState();
                this.board.forEach(function(row, i) {
                    var newRow = row.filter(function(cell) {
                        return cell !== 0;
                    });
                    for(var j = 0; j < newRow.length - 1; j++)if (newRow[j] === newRow[j + 1]) {
                        newRow[j] = newRow[j] * 2;
                        _this.score += newRow[j];
                        newRow[j + 1] = 0;
                        j++;
                    }
                    _this.board[i] = newRow.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(_this.board[i].length < 4)_this.board[i].push(0);
                });
                this.chechGameOver();
                if (!this.boardsAreEqual(oldBoard, this.board)) this.addRandomTile();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this;
                var oldBoard = this.getState();
                this.board.forEach(function(row, i) {
                    var newRow = row.filter(function(cell) {
                        return cell !== 0;
                    });
                    for(var j = newRow.length - 1; j > 0; j--)if (newRow[j] === newRow[j - 1]) {
                        newRow[j] = newRow[j] * 2;
                        _this.score += newRow[j];
                        newRow[j - 1] = 0;
                        j--;
                    }
                    _this.board[i] = newRow.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(_this.board[i].length < 4)_this.board[i].unshift(0);
                });
                this.chechGameOver();
                if (!this.boardsAreEqual(oldBoard, this.board)) this.addRandomTile();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(i) {
                    var col = [];
                    for(var j = 0; j < 4; j++)col.push(_this.board[j][i]);
                    var newCol = col.filter(function(cell) {
                        return cell !== 0;
                    });
                    for(var j1 = 0; j1 < newCol.length - 1; j1++)if (newCol[j1] === newCol[j1 + 1]) {
                        newCol[j1] = newCol[j1] * 2;
                        _this.score += newCol[j1];
                        newCol[j1 + 1] = 0;
                        j1++;
                    }
                    newCol = newCol.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(newCol.length < 4)newCol.push(0);
                    for(var j2 = 0; j2 < 4; j2++)_this.board[j2][i] = newCol[j2];
                };
                var oldBoard = this.getState();
                for(var i = 0; i < 4; i++)_loop(i);
                this.chechGameOver();
                if (!this.boardsAreEqual(oldBoard, this.board)) this.addRandomTile();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(i) {
                    var col = [];
                    for(var j = 0; j < 4; j++)col.push(_this.board[j][i]);
                    var newCol = col.filter(function(cell) {
                        return cell !== 0;
                    });
                    for(var j1 = newCol.length - 1; j1 > 0; j1--)if (newCol[j1] === newCol[j1 - 1]) {
                        newCol[j1] = newCol[j1] * 2;
                        _this.score += newCol[j1];
                        newCol[j1 - 1] = 0;
                        j1--;
                    }
                    newCol = newCol.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(newCol.length < 4)newCol.unshift(0);
                    for(var j2 = 0; j2 < 4; j2++)_this.board[j2][i] = newCol[j2];
                };
                var oldBoard = this.getState();
                for(var i = 0; i < 4; i++)_loop(i);
                this.chechGameOver();
                if (!this.boardsAreEqual(oldBoard, this.board)) this.addRandomTile();
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
            }
        },
        {
            key: "start",
            value: function start() {
                this.score = 0;
                this.board = Array.from({
                    length: 4
                }, function() {
                    return Array(4).fill(0);
                });
                this.status = "playing";
                this.addRandomTile();
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string}

  start() {
    this.score = 0;
    this.board = Array.from({ length: 4 }, () => Array(4).fill(0));
    this.status = 'playing';
    this.addRandomTile();
  }

  /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.board = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                this.score = 0;
                this.status = "idle";
            }
        },
        {
            key: "boardsAreEqual",
            value: function boardsAreEqual(board1, board2) {
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    if (board1[i][j] !== board2[i][j]) return false;
                }
                return true;
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var mas = this.getRandomTile();
                var numberRandom = Math.floor(Math.random() * mas.length);
                var number = Math.random() < 0.9 ? 2 : 4;
                this.board[mas[numberRandom].i][mas[numberRandom].j] = number;
            }
        },
        {
            key: "getRandomTile",
            value: function getRandomTile() {
                var masEmpty = [];
                for(var i = 0; i < 4; i++){
                    for(var j = 0; j < 4; j++)if (this.board[i][j] === 0) masEmpty.push({
                        i: i,
                        j: j
                    });
                }
                return masEmpty;
            }
        },
        {
            key: "chechGameOver",
            value: function chechGameOver() {
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    if (this.board[i][j] === 2048) {
                        this.status = "win";
                        return;
                    }
                    if (this.board[i][j] === 0) return;
                    if (i < 3 && this.board[i][j] === this.board[i + 1][j]) return;
                    if (j < 3 && this.board[i][j] === this.board[i][j + 1]) return;
                }
                this.status = "lose";
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$gameScore = document.querySelector(".game-score");
var $197cd56b15c33885$var$buttonStart = document.querySelector(".button");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$tilesContainer = document.querySelector(".tiles-container");
var $197cd56b15c33885$var$tilesMap = {};
function $197cd56b15c33885$var$showMessage(message) {
    switch(message){
        case "lose":
            $197cd56b15c33885$var$messageLose.classList.remove("hidden");
            break;
        case "win":
            $197cd56b15c33885$var$messageWin.classList.remove("hidden");
            break;
        default:
    }
}
function $197cd56b15c33885$var$updateScore(score) {
    $197cd56b15c33885$var$gameScore.textContent = score;
}
function $197cd56b15c33885$var$updateBoard(board) {
    var newTilesMap = {};
    board.forEach(function(row, y) {
        row.forEach(function(value, x) {
            var key = "".concat(x, "-").concat(y);
            if (value === 0) {
                if ($197cd56b15c33885$var$tilesMap[key]) $197cd56b15c33885$var$tilesContainer.removeChild($197cd56b15c33885$var$tilesMap[key]);
                return;
            }
            if ($197cd56b15c33885$var$tilesMap[key]) {
                $197cd56b15c33885$var$tilesMap[key].style.transition = "transform 1.15s ease-in-out";
                $197cd56b15c33885$var$tilesMap[key].textContent = value;
                $197cd56b15c33885$var$tilesMap[key].className = "tile tile--".concat(value);
                $197cd56b15c33885$var$tilesMap[key].style.transform = "translate(".concat(x * 90, "px, ").concat(y * 90, "px) scale(1)");
                newTilesMap[key] = $197cd56b15c33885$var$tilesMap[key];
            } else {
                var tile = document.createElement("div");
                tile.classList.add("tile", "tile--".concat(value));
                tile.textContent = value;
                tile.style.transform = "translate(".concat(x * 90, "px, ").concat(y * 90, "px) scale(0.5)");
                $197cd56b15c33885$var$tilesContainer.appendChild(tile);
                requestAnimationFrame(function() {
                    tile.style.transition = "transform 0.25s ease-in-out";
                    tile.style.transform = "translate(".concat(x * 90, "px, ").concat(y * 90, "px) scale(1)");
                });
                newTilesMap[key] = tile;
            }
        });
    });
    $197cd56b15c33885$var$updateScore($197cd56b15c33885$var$game.getScore());
    $197cd56b15c33885$var$tilesMap = newTilesMap;
}
$197cd56b15c33885$var$buttonStart.addEventListener("click", function(e) {
    if (!$197cd56b15c33885$var$game || $197cd56b15c33885$var$game.getStatus() !== "playing") {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$buttonStart.textContent = "Restart";
        $197cd56b15c33885$var$buttonStart.className = "button restart";
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$buttonStart.textContent = "Start";
        $197cd56b15c33885$var$buttonStart.className = "button start";
    }
    $197cd56b15c33885$var$updateBoard($197cd56b15c33885$var$game.getState());
    $197cd56b15c33885$var$updateScore($197cd56b15c33885$var$game.getScore());
    $197cd56b15c33885$var$messageStart.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
});
document.addEventListener("keydown", function(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") // eslint-disable-next-line no-useless-return
    return;
    switch(e.key){
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        default:
    }
    $197cd56b15c33885$var$updateBoard($197cd56b15c33885$var$game.getState());
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$showMessage($197cd56b15c33885$var$game.getStatus());
});
var $197cd56b15c33885$var$themeSwitch = document.getElementById("switch");
$197cd56b15c33885$var$themeSwitch.addEventListener("change", function() {
    document.body.classList.toggle("dark", $197cd56b15c33885$var$themeSwitch.checked);
    document.querySelectorAll("p").forEach(function(p) {
        p.style.color = $197cd56b15c33885$var$themeSwitch.checked ? "#fff" : "#333";
    });
    document.querySelector(".dark-check--p").textContent = $197cd56b15c33885$var$themeSwitch.checked ? "DARK" : "LIGHT";
});
var $197cd56b15c33885$var$startX = 0;
var $197cd56b15c33885$var$startY = 0;
var $197cd56b15c33885$var$gameContainer = document.querySelector(".game-container");
$197cd56b15c33885$var$gameContainer.addEventListener("touchstart", function(e) {
    e.preventDefault();
    var touch = e.touches[0];
    $197cd56b15c33885$var$startX = touch.clientX;
    $197cd56b15c33885$var$startY = touch.clientY;
}, {
    passive: false
});
$197cd56b15c33885$var$gameContainer.addEventListener("touchend", function(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    var touch = e.changedTouches[0];
    var diffX = touch.clientX - $197cd56b15c33885$var$startX;
    var diffY = touch.clientY - $197cd56b15c33885$var$startY;
    if (Math.abs(diffX) > Math.abs(diffY)) {
        if (diffX > 0) $197cd56b15c33885$var$game.moveRight();
        else $197cd56b15c33885$var$game.moveLeft();
    } else if (Math.abs(diffY) > 0) {
        if (diffY > 0) $197cd56b15c33885$var$game.moveDown();
        else $197cd56b15c33885$var$game.moveUp();
    }
    $197cd56b15c33885$var$updateBoard($197cd56b15c33885$var$game.getState());
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$showMessage($197cd56b15c33885$var$game.getStatus());
}, {
    passive: false
});

})();
//# sourceMappingURL=index.67068a09.js.map
